import { createContext, useContext } from "react";

import { MarketingVoucherI18nFormModelContext } from "../../_context/context";

import type { MarketingVoucherI18nFormModelContextType } from "../../_context/context";

export type MarketingExistingVoucherI18nFormModelContextType = {
	onUpdate: () => void;
} & MarketingVoucherI18nFormModelContextType;

export const MarketingExistingVoucherI18nFormModelContext =
	createContext<MarketingExistingVoucherI18nFormModelContextType | null>(null);

export const MarketingExistingVoucherI18nFormModelContextProvider = ({
	value,
	children,
}: {
	value: MarketingExistingVoucherI18nFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<MarketingExistingVoucherI18nFormModelContext.Provider value={value}>
			<MarketingVoucherI18nFormModelContext.Provider value={value}>
				{children}
			</MarketingVoucherI18nFormModelContext.Provider>
		</MarketingExistingVoucherI18nFormModelContext.Provider>
	);
};

export const useMarketingExistingVoucherI18nFormModelContext = () => {
	const context = useContext(MarketingExistingVoucherI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useMarketingExistingVoucherI18nFormModelContext must be used within a MarketingExistingVoucherI18nFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
